import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Aetna",
  shortName: "Aetna",
  slug: "aetna-insurance",
  seoTitle: "Aetna TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Aetna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna plan in Coral Springs, FL.",
  seoKeywords:
    "Aetna TMS coverage, Aetna TMS therapy, Aetna depression treatment Florida, Aetna mental health benefits Coral Springs FL, Aetna SAINT TMS",
  planType: "national health insurance provider (CVS Health subsidiary)",
  planRegion: "nationwide",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Aetna is one of the largest national health insurance providers, offering a wide range of commercial, employer-sponsored, Medicare Advantage, and Medicaid plans. Aetna plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Aetna offers many plan types — including HMO, PPO, EPO, and POS networks — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.aetna.com/",
  officialResourceLabel: "Aetna official website",
};

export const AetnaInsurance = () => <InsurancePageTemplate config={config} />;
export default AetnaInsurance;
